import React from 'react';

const ArrowDownIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0005 14.1862L18.429 7.75774C18.8195 7.36721 19.4526 7.36721 19.8432 7.75774C20.2337 8.14826 20.2337 8.78143 19.8432 9.17195L12.7721 16.243C12.5604 16.4547 12.2775 16.5516 12.0005 16.5338C11.7236 16.5516 11.4406 16.4547 11.229 16.243L4.15789 9.17195C3.76737 8.78143 3.76737 8.14826 4.15789 7.75774C4.54842 7.36721 5.18158 7.36721 5.5721 7.75774L12.0005 14.1862Z"
      fill="black"
    />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="3"
      y="7"
      width="18"
      height="10"
    >
      <path
        d="M12.0005 14.1862L18.429 7.75774C18.8195 7.36721 19.4526 7.36721 19.8432 7.75774C20.2337 8.14826 20.2337 8.78143 19.8432 9.17195L12.7721 16.243C12.5604 16.4547 12.2775 16.5516 12.0005 16.5338C11.7236 16.5516 11.4406 16.4547 11.229 16.243L4.15789 9.17195C3.76737 8.78143 3.76737 8.14826 4.15789 7.75774C4.54842 7.36721 5.18158 7.36721 5.5721 7.75774L12.0005 14.1862Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)">
      <rect width="24" height="24" fill="#EEF0F2" />
    </g>
  </svg>
);

export default ArrowDownIcon;
